import { Text } from 'blaze-ui/Text/Text'
import Styles from './AspectRatio.module.scss'
import { AspectRatioProps } from './Types'
import { Pressable } from '@react-aria/interactions'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { Heading } from 'blaze-ui/Heading/Heading'

export const AspectRatio = ({ icon: Icon, name, width, height, onSelect }: AspectRatioProps) => {
  return (
    <Pressable onPress={onSelect}>
      <div className={Styles.aspectRatio}>
        <Icon />
        <span className={Styles.name}>
          <ResponsiveDesign.Desktop>
            <Text variant="smallList">{name}</Text>
          </ResponsiveDesign.Desktop>
          <ResponsiveDesign.Mobile>
            <Heading level={5}>{name}</Heading>
          </ResponsiveDesign.Mobile>
        </span>
        <span className={Styles.description}>
          {width} x {height}
        </span>
      </div>
    </Pressable>
  )
}
